import styled from 'styled-components';
import { mediaQueryWidth } from '../../common/breakpoints';

export const StyledPressCenterContents = styled.div`
  display: grid;
  display: -ms-grid;
  -ms-grid-columns: 50% 50%;
  -ms-grid-rows: auto auto;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;

  ${mediaQueryWidth({ max: 'tablet' })`
      display: flex;
      flex-direction: column;
    `};
`;
